import { Fragment, useEffect } from "react";
import "react-tooltip/dist/react-tooltip.css";
import { Tab } from "@headlessui/react";
import TabList from "../../common/TabList";
import ChartNav from "../../common/ChartNav";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { useParams } from "react-router-dom";
import { fetchNotepad } from "../../../redux/modules/patient/actions";
import PatientAllergies from "./components/allergy/PatientAllergies";
import PatientConditions from "./components/PatientConditions";
import PatientStudies from "./components/PatientStudies";
import PatientSurgeries from "./components/PatientSurgeries";
import LifestyleFactors from "./components/lifestyle-factor/PatientLifestyle";
import ClinicalAlerts from "./components/clinical-alerts/ClinicalAlertsPatient";
import Adherence from "./components/adherence/AdherencePatient";
import Eligibility from "./components/eligibility/EligibilityPatient";
import ActivityLog from "./components/activity-log/ActivityLogPatient";
import SubNavigation from "../clinical-services/common/sub-navigation";

const ClinicalDetail = () => {

  const clinicalDetailTabs = [
    { name: "Allergies", disabled: false },
    {
      name: "Medical History",
      disabled: true,
      children: [
        { name: "Medical Conditions", disabled: false },
        { name: "Medical Studies", disabled: false },
        { name: "Surgeries / Procedures", disabled: false },
      ],
    },
    { name: "Lifestyle Factors", disabled: false },
    { name: "Clinical Alerts", disabled: false },
    { name: "Adherence", disabled: false },
    { name: "Eligibility", disabled: false },
    { name: "Activity Log", disabled: false },
  ];

  const tabComponents = {
    "Allergies": <PatientAllergies />,
    "Medical Conditions": <PatientConditions />,
    "Medical Studies": <PatientStudies />,
    "Surgeries / Procedures": <PatientSurgeries />,
    "Lifestyle Factors": <LifestyleFactors />,
    "Clinical Alerts": <ClinicalAlerts />,
    "Adherence": <Adherence />,
    "Eligibility": <Eligibility />,
    "Activity Log": <ActivityLog />
  };
  

  const { id } = useParams();
  const dispatch = useDispatch();
  const { patient } = useSelector((state) => state.patients);
  const [showMenu, setShowMenu] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [visibleTabs, setVisibleTabs] = useState([]);

  const updateTabs = (expandedParentIndex) => {
    setVisibleTabs(
      clinicalDetailTabs.flatMap((item, index) =>
        expandedParentIndex === index
          ? item.children || [] // Include children of the expanded parent
          : !item.children
          ? [item] // Include individual tabs
          : []
      )
    );
  };

  useEffect(() => {
    dispatch(fetchNotepad(id));
  }, [dispatch]);

  if (!patient) return null;
  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 pt-5 bg-white">
      {/* <div className="flex flex-col"> */}
      <Tab.Group>
        <Tab.Panels as={Fragment}>
          <Tab.Panel as={Fragment}>
            <Tab.Group
              selectedIndex={selectedIndex}
              onChange={setSelectedIndex}
            >
              <div className="flex flex-1 overflow-hidden gap-9">
                <div
                  className={`flex gap-5 relative ${
                    showMenu ? "min-w-[320px] 2xl:min-w-[400px]" : ""
                  }`}
                >
                  <ChartNav />
                  {showMenu && (
                    <div className="w-[318px]">
                      <div className="flex flex-col flex-1 pt-2">
                        <div className="relative mb-4">
                          <h5 className="text-xl font-bold text-teal-300">
                            Clinical Details
                          </h5>
                        </div>
                        <TabList
                          listItems={clinicalDetailTabs}
                          expandedParent={(i) => {
                            updateTabs(i);
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className={`relative w-[7px] transition bg-gray-100 group`}
                  >
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowMenu(!showMenu);
                      }}
                      className={`absolute flex items-center justify-center w-6 h-6 m-auto bg-teal-300 top-64 -right-2 rounded-3xl opacity-100 cursor-pointer `}
                    >
                      {showMenu ? (
                        <ChevronLeftIcon className="w-5 h-5 text-white -ml-0.5" />
                      ) : (
                        <ChevronRightIcon className="w-5 h-5 text-white ml-0.5" />
                      )}
                    </button>
                  </div>
                </div>
                <div
                  className={`flex flex-1 relative ${
                    showMenu
                      ? "max-w-[calc(100%-335px)] 2xl:max-w-[calc(100%-436px)]"
                      : "border-r-4 border-gray-20"
                  }`}
                >
                  <div className="absolute right-2 top-2 z-10">
                    <SubNavigation />
                  </div>
                  <Tab.Panels as={Fragment}>
                    {visibleTabs.map((tab, idx) => (
                      <Tab.Panel as={Fragment} key={idx}>
                        {/* Dynamically render content using the mapping */}
                        {tabComponents[tab.name] || (
                          <div className="pt-8">Coming Soon</div>
                        )}
                      </Tab.Panel>
                    ))}
                  </Tab.Panels>
                </div>
              </div>
            </Tab.Group>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
      {/* </div> */}
    </div>
  );
};

export default ClinicalDetail;
